import { ReactComponent as Arrow } from 'assets/icons/arrowBlue.svg'
import classNames from 'classnames'
import { ScreenEnum, useScreen } from 'feature/screenMode'
import {
  FunctionComponent,
  MouseEventHandler,
  useEffect,
  useState,
} from 'react'
import { Collapse, MenuBlock } from 'ui'

import style from './MenuCollapse.module.scss'

export type MenuCollapseProps = {
  Icon: FunctionComponent
  text: string
  className?: string
  defaultOpen?: boolean
  toggleTestId?: string
  items: {
    Icon: FunctionComponent
    text: string
    link?: string
    blank?: boolean
    handleClick?: MouseEventHandler<HTMLButtonElement>
    hidden?: boolean
    testId?: string
  }[]
}
// раскрывающееся меню на главной странице
export function MenuCollapse({
  Icon,
  text,
  items,
  className,
  defaultOpen,
  toggleTestId,
}: MenuCollapseProps) {
  const [isOpen, setIsOpen] = useState(defaultOpen)
  useEffect(() => {
    setIsOpen(defaultOpen)
  }, [defaultOpen])

  const screen = useScreen()
  useEffect(() => {
    if (screen === ScreenEnum.desktop) {
      setIsOpen(true)
    }
  }, [screen])

  const handleOpen = () => {
    if (screen === ScreenEnum.desktop) {
      return
    }
    setIsOpen(prev => !prev)
  }

  return (
    <div className={classNames(style.menu, className)}>
      <button
        type='button'
        className={style.collapseBtn}
        onClick={handleOpen}
        data-testid={toggleTestId}
      >
        <span className={style.icon}>
          <Icon />
        </span>
        <span className={style.textBtn}>{text}</span>
        <Arrow
          className={classNames(
            style.arrowBtn,
            { rotate90: isOpen },
            'desktop-hidden',
          )}
        />
      </button>
      <Collapse in={isOpen}>
        <div className={style.items}>
          {items
            .filter(item => !item.hidden)
            .map(item => (
              <MenuBlock
                key={item.testId ?? item.text}
                Icon={item.Icon}
                link={item.link}
                text={item.text}
                blank={item.blank}
                className={style.menuBlock}
                handleClick={item.handleClick}
                data-testid={item.testId}
              />
            ))}
        </div>
      </Collapse>
    </div>
  )
}
